import styled from "@emotion/styled";
import { color } from "./color";

export const LocationOutter = styled.div`
  width: 100%;
  padding: 2rem 0;
  background-color: ${color.secondary};
  position: relative;
  &:before {
    content: "";
    width: 100%;
    height: 100%;
    background-color: ${color.secondary};
    position: absolute;
    top: 99%;
    left: 0;
  }
  @media (min-width: 768px) {
    padding: 3rem 0;
    &:before {
      content: none;
    }
  }
`;
export const MobileBtn = styled.div`
  display: inline-block;
  color: ${color.primaryBlue};
  font-size: 1rem;
  font-weight: 600;
  padding: 0.5rem 1rem;
  background-color: white;
  width: 100%;
  border-radius: 0.5rem;
  @media (min-width: 768px) {
    display: none;
    opacity: 0;
    visibility: hidden;
  }
`;
export const BoxMask = styled.div`
  background-color: ${(props: { open: boolean }) =>
    props.open ? "rgba(0,0,0,.5)" : "rgba(0,0,0,0)"};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 15;
  opacity: ${(props: { open: boolean }) => (props.open ? "1" : "0")};
  visibility: ${(props: { open: boolean }) =>
    props.open ? "visible" : "hidden"};
  transition: all 0.3s ease-out;
`;
export const Box = styled.div`
  position: fixed;
  overflow: hidden;
  width: 100%;
  z-index: 20;
  left: 0;
  bottom: ${(props: { open: boolean }) => (props.open ? 0 : "-100%")};
  height: 60vh;
  overflow: scroll;
  background-color: white;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  transition: all 0.3s ease-out;
  @media (min-width: 768px) {
    display: grid;
    display: -ms-grid;
    grid-template-columns: repeat(auto-fill, 10%);
    justify-content: space-between;
    grid-gap: 1rem;
    background-color: rgba(0, 0, 0, 0);
    overflow: visible;
    width: 100%;
    height: auto;
    position: relative;
  }
`;
export const CnCounty = styled.div`
  padding: 1.5rem;
  min-width: 74px;
  text-align: center;
  transition: all 0.3s ease-out;
  @media (min-width: 768px) {
    padding: 1rem;
    border-radius: 0.5rem;
    cursor: pointer;
    &:hover {
      transform: translate(-0.5em, -0.5em);
      box-shadow: 0.3em 0.3em ${color.markedSecondary};
    }
  }
`;
export const MatchDetail = styled.div`
  width: 100%;
  background-color: white;
  padding: 2rem 0;
  position: relative;
  border-radius: 1rem;
  @media (min-width: 768px) {
    padding: 3rem 0;
  }
  .switch {
    display: flex;
  }
  .tabsBar {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    margin-bottom: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    .ant-tabs-tab {
      background-color: ${color.secondary};
      border-top-left-radius: 0.5rem !important;
      border-top-right-radius: 0.5rem !important;
      .ant-tabs-tab-btn {
        color: ${color.default};
      }
    }
    .ant-tabs-nav .ant-tabs-tab-active {
      background-color: ${color.markedDefault};
      .ant-tabs-tab-btn {
        color: ${color.primaryBlue};
      }
    }
    .ant-dropdown-link {
      background-color: rgba(0, 0, 0, 0);
      border: none;
      text-align: left;
    }
    .ant-dropdown-trigger {
      margin-left: 0.5rem;
      color: ${color.markedSecondary};
    }
    .ant-tabs-nav {
      margin: 0;
    }
  }
  table {
  }
  th.ant-table-cell {
    background-color: ${color.primaryBlue} !important;
    color: white;
    &:first-of-type {
      border-top-left-radius: 0.5rem !important;
    }
    &:last-of-type {
      border-top-right-radius: 0.5rem !important;
    }
  }
  .ant-table-row {
    background-color: #ffb8b8;
    &:nth-of-type(5n + 2),
    &:nth-of-type(5n + 3),
    &:nth-of-type(5n + 4),
    &:nth-of-type(5n + 5),
    &:nth-of-type(5n + 6) {
      background-color: #ffffff;
    }
    &:nth-of-type(10n + 7),
    &:nth-of-type(10n + 8),
    &:nth-of-type(10n + 9),
    &:nth-of-type(10n + 10),
    &:nth-of-type(10n + 11) {
      background-color: #f1f1f1;
    }
  }
  .ant-table-cell-scrollbar {
    box-shadow: none;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background-color: #ffe0a3;
  }
`;
export const MatchPlace = styled.div`
  border-radius: 0.5rem;
  border: 1px solid ${color.primaryBlue};
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  padding: 1rem;
  margin-bottom: 1rem;
  overflow: hidden;
  .county {
    font-weight: bold;
    color: white;
    font-size: 1.25rem;
    border-bottom: 1px solid white;
    padding: 1rem;
    background-color: ${color.primaryBlue};
    margin: -1rem -1rem 0 -1rem;
  }
  .matchInfo {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin: 0 -1rem;
    transition: all 0.4s;
  }
  .matchWrapper {
    cursor: pointer;
    color: white;
    transition: all 0.4s;
    font-size: 1rem;
    width: 100%;
    .matches {
      padding: 0.5rem 1rem;
      color: ${color.primaryBlue};
      width: 100%;
      display: flex;
      justify-content: space-between;
      transition: all 0.4s ease-out;
    }
    .subMenu {
      font-size: 0.8rem;
      position: relative;
      padding: 0.5rem 1rem;
      transition: all 0.4s ease-out;
      color: ${color.primaryBlue};
      &:hover {
        background-color: ${color.markedSecondary};
        color: white;
      }
    }
  }
`;
